import axios from "axios";
import type { Department } from '@/store/management/departmentsStore';
import type { ProductGroup } from '@/store/management/productGroupsStore';
import type { CondimentGroup, Condiment } from '@/store/management/condimentsStore';
import type { TaxDetail } from '@/store/management/taxesStore';
import type { Basic, Product, SetItems } from '@/store/management/productsStore';
import { departmentToViviposCategory, viviposCategoryToDepartment } from '@/store/management/departmentsStore';
import { productGroupToViviposProductGroup, viviposProductGroupToProductGroup } from '@/store/management/productGroupsStore';
import { condimentGroupToViviposCondimentGroups, viviposCondimentGroupsToCondimentGroup, condimentToViviposCondiments, viviposCondimentsToCondiment } from '@/store/management/condimentsStore';
import { taxDetailToViviposTax, viviposTaxToTaxDetail } from '@/store/management/taxesStore';
import { productToVivipos, setItemToVivipos } from '@/store/management/productsStore';

// const API_URL = "http://localhost:8888";
const API_URL = "https://eservice-api.myposbuddy.com/api";
export const getAllCategories = async (): Promise<Department[]> => {
    const token = "12352";
    try {
        const { data } = await axios.get(`${API_URL}/vivipos_categories`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!Array.isArray(data)) {
            throw new Error("Invalid response format: expected an array");
        }
        return data.map((item: any) => viviposCategoryToDepartment(item));
    } catch (error: any) {
        console.error("Error fetching categories:", error?.response?.data || error.message);
        throw error;
    }
};

export const addDepartmentAPI = async (payload: Department) => {
    const token = "12352";
    const departmentPayload = departmentToViviposCategory(payload);
    try {
        const { data } = await axios.post(`${API_URL}/vivipos_categories`, departmentPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    } catch (error: any) {
        console.error("Error adding department:", error?.response?.data || error.message);
        throw error;
    }
};

export const updateDepartmentAPI = async (payload: Department) => {
    const token = "12352";
    const departmentPayload = departmentToViviposCategory(payload);
    try {
        const { data } = await axios.put(`${API_URL}/vivipos_categories/1/${payload.id}`, departmentPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error updating department:", error?.response?.data || error.message);
        throw error;
    }
};

export const deleteDepartmentAPI = async (id: string) => {
    const token = "12352";
    try {
        const { data } = await axios.delete(`${API_URL}/vivipos_categories/1/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    } catch (error: any) {
        console.error("Error deleting department:", error?.response?.data || error.message);
        throw error;
    }
};


export const getAllProductGroupAPI = async (): Promise<ProductGroup[]> => {
    const token = "12352";
    try {
        const { data } = await axios.get(`${API_URL}/vivipos_plugroups`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!Array.isArray(data)) {
            throw new Error("Invalid response format: expected an array");
        }
        return data.map((item: any) => viviposProductGroupToProductGroup(item));
    } catch (error: any) {
        console.error("Error fetching product groups:", error?.response?.data || error.message);
        throw error;
    }
};

export const addProductGroupAPI = async (payload: ProductGroup) => {
    const token = "12352";
    const departmentPayload = productGroupToViviposProductGroup(payload);
    try {
        const { data } = await axios.post(`${API_URL}/vivipos_plugroups`, departmentPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    } catch (error: any) {
        console.error("Error adding product group:", error?.response?.data || error.message);
        throw error;
    }
};

export const updateProductGroupAPI = async (payload: ProductGroup) => {
    const token = "12352";
    const departmentPayload = productGroupToViviposProductGroup(payload);
    try {
        const { data } = await axios.put(`${API_URL}/vivipos_plugroups/1/${payload.id}`, departmentPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error updating product group:", error?.response?.data || error.message);
        throw error;
    }
};

export const deleteProductGroupAPI = async (id: string) => {
    const token = "12352";
    try {
        const { data } = await axios.delete(`${API_URL}/vivipos_plugroups/1/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error deleting product group:", error?.response?.data || error.message);
        throw error;
    }
};

export const getAllCondimentGroupAPI = async (): Promise<CondimentGroup[]> => {
    const token = "12352";
    try {
        const { data } = await axios.get(`${API_URL}/vivipos_condiment_groups`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!Array.isArray(data)) {
            throw new Error("Invalid response format: expected an array");
        }
        return data.map((item: any) => viviposCondimentGroupsToCondimentGroup(item));
    } catch (error: any) {
        console.error("Error fetching condiment groups:", error?.response?.data || error.message);
        throw error;
    }
};

export const addCondimentGroupAPI = async (payload: CondimentGroup) => {
    const token = "12352";
    const condimentGroupPayload = condimentGroupToViviposCondimentGroups(payload);
    try {
        const { data } = await axios.post(`${API_URL}/vivipos_condiment_groups`, condimentGroupPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    } catch (error: any) {
        console.error("Error adding condiment group:", error?.response?.data || error.message);
        throw error;
    }
};

export const updateCondimentGroupAPI = async (payload: CondimentGroup) => {
    const token = "12352";
    const condimentGroupPayload = condimentGroupToViviposCondimentGroups(payload);
    try {
        const { data } = await axios.put(`${API_URL}/vivipos_condiment_groups/1/${payload.id}`, condimentGroupPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error updating condiment group:", error?.response?.data || error.message);
        throw error;
    }
};

export const deleteCondimentGroupAPI = async (id: string) => {
    const token = "12352";
    try {
        const { data } = await axios.delete(`${API_URL}/vivipos_condiment_groups/1/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error deleting condiment group:", error?.response?.data || error.message);
        throw error;
    }
};

export const addCondimentAPI = async (payload: Condiment) => {
    const token = "12352";
    const condimentsPayload = condimentToViviposCondiments(payload);
    try {
        const { data } = await axios.post(`${API_URL}/vivipos_condiments`, condimentsPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    } catch (error: any) {
        console.error("Error adding condiments :", error?.response?.data || error.message);
        throw error;
    }
};

export const getAllCondimentsByGroupAPI = async (group_id: string): Promise<Condiment[]> => {
    const token = "12352";
    try {
        const { data } = await axios.get(`${API_URL}/vivipos_condiments/group/1/${group_id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!Array.isArray(data)) {
            throw new Error("Invalid response format: expected an array");
        }
        return data.map((item: any) => viviposCondimentsToCondiment(item));
    } catch (error: any) {
        console.error("Error fetching condiment :", error?.response?.data || error.message);
        throw error;
    }
};

export const updateCondimentAPI = async (payload: Condiment) => {
    const token = "12352";
    const condimentsPayload = condimentToViviposCondiments(payload);
    try {
        const { data } = await axios.put(`${API_URL}/vivipos_condiments/1/${payload.id}`, condimentsPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error updating condiments :", error?.response?.data || error.message);
        throw error;
    }
};
export const deleteCondimentAPI = async (id: string) => {
    const token = "12352";
    try {
        const { data } = await axios.delete(`${API_URL}/vivipos_condiments/1/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error deleting condiments :", error?.response?.data || error.message);
        throw error;
    }
};

export const getAllTaxesAPI = async (): Promise<TaxDetail[]> => {
    const token = "12352";
    try {
        const { data } = await axios.get(`${API_URL}/vivipos_taxes`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return data.map((item: any) => viviposTaxToTaxDetail(item));;
    }
    catch (error: any) {
        console.error("Error fetching taxes:", error?.response?.data || error.message);
        throw error;
    }
};

export const addTaxAPI = async (payload: TaxDetail) => {
    const token = "12352";
    const taxPayload = taxDetailToViviposTax(payload);
    try {
        const { data } = await axios.post(`${API_URL}/vivipos_taxes`, taxPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error adding tax:", error?.response?.data || error.message);
        throw error;
    }
};

export const updateTaxAPI = async (payload: TaxDetail) => {
    const token = "12352";
    const taxPayload = taxDetailToViviposTax(payload);
    try {
        const { data } = await axios.put(`${API_URL}/vivipos_taxes/1/${payload.id}`, taxPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error updating tax:", error?.response?.data || error.message);
        throw error;
    }
};

export const deleteTaxAPI = async (id: string) => {
    const token = "12352";
    try {
        const { data } = await axios.delete(`${API_URL}/vivipos_taxes/1/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error deleting tax:", error?.response?.data || error.message);
        throw error;
    }
};

export const updateTaxDefaultAPI = async (id: string) => {
    const token = "12352";
    try {
        const { data } = await axios.put(`${API_URL}/vivipos_taxes/set_default/1/${id}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    } catch (error: any) {
        console.error("Error updating tax default:", error?.response?.data || error.message);
        throw error;
    }
};

export const clearDefaultTaxAPI = async (id: string) => {
    const token = "12352";
    try {
        const { data } = await axios.get(`${API_URL}/vivipos_taxes/clear_default/1/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error clearing default tax:", error?.response?.data || error.message);
        throw error;
    }
};

export const getAllDepartments = async (): Promise<Department[]> => {
    const token = "12352";
    try {
        const { data } = await axios.get(`${API_URL}/vivipos_categories`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!Array.isArray(data)) {
            throw new Error("Invalid response format: expected an array");
        }
        return data;
    } catch (error: any) {
        console.error("Error fetching categories:", error?.response?.data || error.message);
        throw error;
    }
};

export const getAllProducts = async (): Promise<Product[]> => {
    const token = "12352";
    try {
        const { data } = await axios.get(`${API_URL}/vivipos_products`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const productsArray = Array.isArray(data)
            ? data
            : Array.isArray(data?.products)
                ? data.products
                : [];

        if (!Array.isArray(productsArray)) {
            throw new Error("Invalid response format: expected an array");
        }
        return productsArray;
    } catch (error: any) {
        console.error("Error fetching products:", error?.response?.data || error.message);
        throw error;
    }
};

export const addProductAPI = async (payload: Product) => {
    const token = "12352";
    const productPayload = productToVivipos(payload);
    const product = { ...productPayload.ViviposProduct };
    try {
        const { data } = await axios.post(`${API_URL}/vivipos_products`, product, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error adding product:", error?.response?.data || error.message);
        throw error;
    }
};

export const deleteProductAPI = async (id: string) => {
    const token = "12352";
    try {
        const { data } = await axios.delete(`${API_URL}/vivipos_products/1/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error deleting product:", error?.response?.data || error.message);
        throw error;
    }
};

export const updateProductAPI = async (payload: Product) => {
    const token = "12352";
    const productPayload = productToVivipos(payload);

    try {
        const { data } = await axios.put(`${API_URL}/vivipos_products/1/${payload.basic.id}`, productPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error updating product:", error?.response?.data || error.message);
        throw error;
    }
};

export const addSetItemAPI = async (payload: SetItems) => {
    const token = "12352";
    const productPayload = setItemToVivipos(payload);
    try {
        const { data } = await axios.post(`${API_URL}/vivipos_set_items`, productPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    }
    catch (error: any) {
        console.error("Error adding set item:", error?.response?.data || error.message);
        throw error;
    }
};